import { Link, navigate } from "gatsby";
import React from "react";
import Icon from "../Icon";
import { LiContainer } from "./styles";

const ListItemTemplate = ({
  iconStyle,
  iconType,
  iconAlignment,
  children,
  alignment,
}) => (
  <LiContainer alignment={alignment} icon_style={iconStyle}>
    {iconType && iconAlignment === "left" && <Icon type={iconType} />}
    {children}
    {iconType && iconAlignment === "right" && <Icon type={iconType} />}
  </LiContainer>
);

const LinkListItem = ({
  iconType,
  iconAlignment = "left",
  linkURL = "",
  text,
  linkStyle,
  iconStyle,
  children,
  disabled = false,
  navProps,
  cb,
}) => {
  const isInternalLink = linkURL?.[0] === "/" ?? false;
  const content = text || children;

  if (disabled) {
    return (
      <ListItemTemplate alignment="flex-start">{children}</ListItemTemplate>
    );
  }

  if (isInternalLink) {
    const navItem = navProps ? (
      <div
        className={`link ${iconType}-icon`}
        onClick={() => {
          cb?.();
          navigate(linkURL, { state: { ...navProps } });
        }}
      >
        {content}
      </div>
    ) : (
      <Link className={`link ${iconType}-icon`} to={linkURL} style={linkStyle}>
        {content}
      </Link>
    );
    return (
      <ListItemTemplate
        iconType={iconType}
        iconAlignment={iconAlignment}
        iconStyle={iconStyle}
        disabled={false}
      >
        {navItem}
      </ListItemTemplate>
    );
  } else {
    return (
      <ListItemTemplate
        iconType={iconType}
        iconAlignment={iconAlignment}
        iconStyle={iconStyle}
      >
        <a
          className={`link ${iconType}-icon`}
          style={linkStyle}
          href={`${linkURL}`}
          disabled={disabled}
        >
          {content}
        </a>
      </ListItemTemplate>
    );
  }
};

export default LinkListItem;
